import React from 'react'
import { CheckCircle, XCircle } from 'lucide-react'

import { Badge } from '@rewardops/replit/src/components/ui/badge'
import { Button } from '@rewardops/replit/src/components/ui/button'
import { Card, CardContent } from '@rewardops/replit/src/components/ui/card'
import { Spinner } from '@rewardops/ui'

import { useApi } from '~/components/hooks/use-api'
import { PAWSectionType } from './paw-section-types'

export const PendingManualAdjustments: React.FC<PAWSectionType> = ({
  content,
  data,
}: PAWSectionType) => {
  const { api } = useApi()

  const { data: adjustmentData, isLoading } =
    api.pawDashboards.getByRole.useQuery({
      role: data?.role,
      sectionId: content?.sectionId,
    })

  return (
    <section data-testid={content?.sectionId} id={content?.sectionId}>
      <h2 className="mb-6 text-xl font-semibold">
        {content?.title ?? 'Pending Manual Adjustments'}
      </h2>
      <Card>
        <CardContent className="pt-6">
          {isLoading ? (
            <Spinner />
          ) : (
            <div className="space-y-4">
              {adjustmentData?.map((adjustment: any) => (
                <div
                  key={adjustment.id}
                  className="rounded-lg border bg-card p-4"
                  data-testid={`adjustment-${adjustment.id}`}
                >
                  <div className="flex items-start justify-between gap-4">
                    <div className="flex-1">
                      <div className="mb-2 flex items-center gap-2">
                        <h4 className="font-medium">{adjustment.user}</h4>
                        <Badge
                          variant={
                            adjustment.points > 0 ? 'default' : 'outline'
                          }
                        >
                          {adjustment.points > 0 ? '+' : ''}
                          {adjustment.points.toLocaleString()} pts
                        </Badge>
                      </div>
                      <p className="mb-2 text-sm text-muted-foreground">
                        {adjustment.reason}
                      </p>
                      <div className="flex items-center gap-4 text-sm text-muted-foreground">
                        <span>Requested by: {adjustment.requestedBy}</span>
                        <span>{adjustment.date}</span>
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <Button
                        size="sm"
                        variant="default"
                        className="p-2"
                        data-testid={`button-approve-${adjustment.id}`}
                      >
                        <CheckCircle className="mr-1 h-4 w-4" />
                        Approve
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        className="p-2"
                        data-testid={`button-reject-${adjustment.id}`}
                      >
                        <XCircle className="mr-1 h-4 w-4" />
                        Reject
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </section>
  )
}
